import { isCanlan } from './customer-name'

/* Felipe Nunes: Updated Sunday, 20 Nov 1:11PM ( BRT ) */
// If it fails (like if the previously set hardcoded token is expired)
// try setting the hardcoded token again (hopefully a new one)
// {
//   "access_token": "v2.local.Et6bxhAmLBAYEBQyxLWWHMXSid_AFti6KkzsCdFTSIOlL-Ms31vp_U6dzEm35WAa9ZSW9HgWpJir9e-_S8pjaODsrCnL3D-9jhzlIkqc2EDH6OLZbvTVRD1aRr-weR_C4c_8sPDBUNKE59tLHtb6BWMcKVN39MrzFCqyPrqDI68diAD6KfEqgxVBGqkOegpjXXBjrQOBTCSiW_-8vAf_zB0hlYcThwXaq4m_-ZBG5g58J85Jp124-vMRdg8TyOuIst3d7KRpLOWx22635TJB_aVEc9CNy6Q",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2023-11-27T16:08:18.245842Z",
//   "user": {
//     "id": "TAcc3KT6ikeaqhvL",
//     "email": "michael+planeticeservice@sportninja.com",
//     "created_at": "2022-08-29T23:14:34+00:00",
//     "updated_at": "2023-11-20T16:08:12+00:00",
//     "validated_at": "2022-08-29T23:14:42+00:00"
//   }
// }
const planetIceToken =
  'v2.local.Et6bxhAmLBAYEBQyxLWWHMXSid_AFti6KkzsCdFTSIOlL-Ms31vp_U6dzEm35WAa9ZSW9HgWpJir9e-_S8pjaODsrCnL3D-9jhzlIkqc2EDH6OLZbvTVRD1aRr-weR_C4c_8sPDBUNKE59tLHtb6BWMcKVN39MrzFCqyPrqDI68diAD6KfEqgxVBGqkOegpjXXBjrQOBTCSiW_-8vAf_zB0hlYcThwXaq4m_-ZBG5g58J85Jp124-vMRdg8TyOuIst3d7KRpLOWx22635TJB_aVEc9CNy6Q'

// {
//   "access_token": "v2.local.-vgLTlPak8qZq2BxGV1QQOYIGTghEdfVUt6_Dca40fvrRaTL7gIcm1mi2nxFqGx94dnk1WtJ4tZh9zeA0CiSZUJKmCXhUkpicit8ZGJ09piq5oE8KhpntMpUJSa7WH_R3KQOHv8WZ5uMkiKXnlWAOv8xPQp54rGJ43myW6VOnOIj-J9L6qz_h9G99ZbHkSdCuUSvDIZ1KiFd45_n2tgriT50_294bb7WyspPYo0pjJndxpMKFAJTt2WzsMGvnI-FOVDqMd0CnfyytN-LUBh4TQm_j4klNP8",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2023-11-27T16:10:01.153046Z",
//   "user": {
//     "id": "oP37ysYCd57bFlkj",
//     "email": "michael+carhaservice@sportninja.com",
//     "created_at": "2022-05-27T18:35:59+00:00",
//     "updated_at": "2023-11-20T16:09:52+00:00",
//     "validated_at": "2022-05-27T18:35:59+00:00"
//   }
// }
const carhaToken =
  'v2.local.-vgLTlPak8qZq2BxGV1QQOYIGTghEdfVUt6_Dca40fvrRaTL7gIcm1mi2nxFqGx94dnk1WtJ4tZh9zeA0CiSZUJKmCXhUkpicit8ZGJ09piq5oE8KhpntMpUJSa7WH_R3KQOHv8WZ5uMkiKXnlWAOv8xPQp54rGJ43myW6VOnOIj-J9L6qz_h9G99ZbHkSdCuUSvDIZ1KiFd45_n2tgriT50_294bb7WyspPYo0pjJndxpMKFAJTt2WzsMGvnI-FOVDqMd0CnfyytN-LUBh4TQm_j4klNP8'

// {
//   "access_token": "v2.local.aRLw_CK1dipupWilwlithhyxqD7U2kmpAx6FCvkAB8gklmW-HtkfyK6CLXv1CpEd4QOrWEi9OnDAopyTvKTsL_F3-AqYV_3EX-c4siDRtkMK5WPpcNaUszxkshfgjWcSlTIkPX6-P9pJ0Tti02reDHXjbs5LFOtCLUy91kcINslntRF3BDXaRkqTEwD-4Jg-fuLs1G6dKpqnQi7mJZf-TVlJ0YHR1fR-8Iqju2o9KS_wNhZ3Y-Uzw784zNWlFFTB10MfgzYVCCuvmVNv2ctKawteQRuY",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2023-11-27T16:06:25.851166Z",
//   "user": {
//     "id": "jJkc8qSsffa24rAE",
//     "email": "michael+canlanservice@sportninja.com",
//     "created_at": "2022-05-30T20:39:26+00:00",
//     "updated_at": "2023-05-19T19:59:44+00:00",
//     "validated_at": "2022-05-30T20:39:26+00:00"
//   }
// }
const canlanToken =
  'v2.local.aRLw_CK1dipupWilwlithhyxqD7U2kmpAx6FCvkAB8gklmW-HtkfyK6CLXv1CpEd4QOrWEi9OnDAopyTvKTsL_F3-AqYV_3EX-c4siDRtkMK5WPpcNaUszxkshfgjWcSlTIkPX6-P9pJ0Tti02reDHXjbs5LFOtCLUy91kcINslntRF3BDXaRkqTEwD-4Jg-fuLs1G6dKpqnQi7mJZf-TVlJ0YHR1fR-8Iqju2o9KS_wNhZ3Y-Uzw784zNWlFFTB10MfgzYVCCuvmVNv2ctKawteQRuY'

export const getIframeToken = () => {
  const parentUrl =
    window.location !== window.parent.location
      ? window?.document?.referrer
      : window?.document?.location?.href

  let isPlanetIce = false
  if (parentUrl && parentUrl.includes('pacificadulthockey.com')) {
    isPlanetIce = true
  }
  return isCanlan ? canlanToken : isPlanetIce ? planetIceToken : carhaToken
}
